import { Skeleton } from 'primereact/skeleton';
import { ReactNode } from 'react';

interface SkeletonProps {
    height?: string;
    shape?: 'circle' | 'rectangle';
    width?: string;
    size?: string;
    empty?: boolean;
    borderRadius?: string | undefined;
}

interface LoadingSkeletonProps {
    scaffold?: boolean;
    elements?: SkeletonProps | SkeletonProps[] | SkeletonProps[][];
}

function LoadingSkeletonCol({
    elements,
}: {
    elements: SkeletonProps[] | SkeletonProps[][];
}) {
    return (
        <div className="flex flex-column gap-2">
            {elements.map((element, index) => {
                return <LoadingSkeletonRow key={index} elements={element} />;
            })}
        </div>
    );
}

function LoadingSkeletonRow({
    elements,
}: {
    elements: SkeletonProps | SkeletonProps[];
}): ReactNode {
    if (!Array.isArray(elements)) {
        return <LoadingSkeleton elements={elements} />;
    }
    return (
        <div className="flex flex-row gap-2 align-items-center">
            {elements.map((subElement, subIndex) => {
                return subElement.empty ? (
                    <div
                        style={{
                            width: subElement.width,
                            height: subElement.height,
                        }}
                        key={subIndex}
                    />
                ) : (
                    <Skeleton key={subIndex} {...subElement} />
                );
            })}
        </div>
    );
}

export function LoadingSkeleton({
    elements,
    scaffold,
}: LoadingSkeletonProps): ReactNode {
    if (scaffold) {
        return (
            <div className="flex flex-column gap-2">
                <Skeleton></Skeleton>
                <Skeleton width="10rem"></Skeleton>
                <Skeleton width="5rem"></Skeleton>
                <Skeleton height="2rem"></Skeleton>
                <Skeleton width="10rem"></Skeleton>
            </div>
        );
    }
    if (!elements) {
        return <Skeleton />;
    }
    if (Array.isArray(elements)) {
        return <LoadingSkeletonCol elements={elements} />;
    }

    return <Skeleton {...elements} />;
}
